import React, { useState } from 'react';
import {
  Container,
  Navbar,
  NavbarBrand,
  Nav,
  NavItem,
  Button,
} from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Alert from '../Common/Modal/Alert';
import * as monitorActions from '../../store/aiConversationMonitor/actions';

/**
 * The bar of components/Leads/BatchLeadBar.js, for the agent's
 * conversations: it shows up at the bottom while something is selected, and
 * carries the one thing a selection is for here — taking it back.
 */
const BatchAiConversationBar = ({ selectedIds, onDone }) => {
  const [confirm, setConfirm] = useState(false);
  const acting = useSelector((state) => state.AiConversationMonitor.acting);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handleConfirm = () => {
    // The selection may have emptied while the confirmation was open: the
    // conversations it held left the list on their own. The saga refuses an
    // empty list too, since that is what the callable reads as "everything".
    if (selectedIds.length)
      dispatch(monitorActions.takeBackAiConversations(selectedIds));
    setConfirm(false);
    onDone();
  };

  return (
    <>
      <div
        className={`fixed-bottom ${
          selectedIds.length ? 'visible' : 'invisible'
        }`}
      >
        <Navbar style={{ backgroundColor: '#2a3042' }} dark expand="md">
          <Container style={{ justifyContent: 'flex-start' }}>
            <NavbarBrand>{t('Manage')}:</NavbarBrand>
            <Nav pills>
              <NavItem>
                <Button
                  color="warning"
                  outline
                  className="waves-effect waves-light"
                  disabled={acting}
                  onClick={() => setConfirm(true)}
                >
                  <i className="bx bx-phone-incoming font-size-20 align-middle mr-2"></i>
                  {t('Back to the call center')} ({selectedIds.length})
                </Button>
              </NavItem>
            </Nav>
          </Container>
        </Navbar>
      </div>
      <Alert
        isOpen={confirm}
        title={t('Take the selected conversations back from the AI?')}
        confirmBtnLabel={t('Take them back')}
        onCancel={() => setConfirm(false)}
        onConfirm={handleConfirm}
      >
        {t(
          'The agent stops writing and the calls go back to the operator queue. Whoever wrote in the last 24 hours receives the handoff message of the acquisition order.',
        )}
      </Alert>
    </>
  );
};

export default BatchAiConversationBar;
